import { GetCalendarResponse, GetCalendarParams } from '../types/my-calendar-types';
import { BaseSettingsEndpoints } from './base';

const MY_CALENDAR_BASE_PATH = '/v1/me/calendar';

export class MyCalendarClient extends BaseSettingsEndpoints {
  async getCalendar(params: GetCalendarParams) {
    const queryParams: Record<string, string | string[]> = {
      tz: params.tz
    };

    if (params.date) {
      queryParams.date = params.date;
    }

    if (params.user_id) {
      queryParams.user_id = params.user_id;
    }

    const url = this.addGenericParamsToUrl(MY_CALENDAR_BASE_PATH, queryParams);
    return this.get<GetCalendarResponse>(url);
  }
} 